export interface ITripRequestLogsStatsSchema {
    distinctTripCodesCount: number;
    createdTripsCount: number;
    failedTripsCount: number;
    successRate: string;
    totalRequestsCount: number;
    successfulRequestsCount: number;
    failedRequestsCount: number;
    failedTripCodes: string[];
}
